module.exports = __webpack_public_path__ + "static/media/0.997396c5.jpg";